/**
 * @fileoverview Shared constants for the student "My tasks" module (no magic
 * numbers spread across components). Includes layout sizes and skeleton
 * dimensions that mirror the real components.
 */

/** Filter sentinel meaning "all projects". */
export const ALL_PROJECTS = 'all'

/** Right-side drawer width, responsive to viewport. */
export const DRAWER_WIDTH = 'min(720px, 100vw)'

/** Action button width on each card (desktop). */
export const CARD_ACTION_WIDTH = 220

/** How many task cards the list skeleton renders. */
export const LIST_SKELETON_COUNT = 4

/** Valid self-score range for evaluative items. */
export const MIN_SCORE = 1
export const MAX_SCORE = 5

/** Skeleton dimensions, mirroring the real layout 1:1 (plan Parte 6). */
export const SKELETON = {
  card: {
    typeLabel: { height: 16, width: 120 },
    badge: { height: 18, width: 70 },
    dueDate: { height: 16, width: 90 },
    columnLabel: { height: 12, width: 60 },
    columnValue: { height: 16, width: 140 },
    action: { height: 36, width: CARD_ACTION_WIDTH },
  },
  filter: { height: 36, width: 320 },
  /** Project/lesson bar lines (Text size="sm") + right-side "Created by". */
  infoBar: { line: { height: 14, width: 180 }, side: { height: 14, width: 120 } },
  deliverable: {
    title: { height: 18, width: '55%' },
    badge: { height: 18, width: 70 },
    due: { height: 14, width: '35%' },
    label: { height: 14, width: 110 },
    instructionLine: { height: 12 },
    instructionWidths: ['100%', '90%', '70%'],
    textarea: { height: 80 },
    uploadButton: { height: 36, width: 140 },
    gdriveButton: { height: 36, width: 160 },
  },
  assessment: {
    /** Title order={5} section headings ("Skills" / "Standards" / "Files"). */
    sectionTitle: { height: 20, width: 110 },
    skillRows: 2,
    standardRows: 1,
    /** AssessmentScoreItem: 4px colored left border + two text lines. */
    cardBorderLeft: 4,
    itemCategory: { height: 12, width: '40%' },
    itemName: { height: 14, width: '60%' },
    /** ScorePicker hand buttons: 56x56, 8px radius, Group spacing="xs". */
    scoreBox: { size: 56, radius: 8 },
    filesButton: { height: 36, width: 120 },
    notesLabel: { height: 14, width: 80 },
    notesBox: { height: 80 },
  },
} as const
